import { useMutation } from '@tanstack/react-query'
import { getAnnouncementBannerUploadFileUrl } from '@/modules/client-setting/api/services'
import { UseBaseMutationOptions } from '@/core/api/type'
import { LoginAnnouncementMutationKeys } from '@/modules/client-setting/keys'

interface CreateFileUrlParams {
	payload: { fileExtension: string }
}

interface GetUploadFileUrlResponse {
	presignedUrl: string
	fileUrl: string
}

export default function useMutationGetAnnouncementBannerUploadFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [
			LoginAnnouncementMutationKeys.GetAnnouncementBannerUploadFileUrl,
		],
		mutationFn: (params) => getAnnouncementBannerUploadFileUrl(params.payload),
		...props,
	})
}
